import type { OptionsInterface, SelectInterface } from '@connect-field/client/components/forms/form.types';

export const labels = {
    arrimage_gaine: 'Arrimage de la gaine de protection des micro-modules',
    cheminement_lovage: 'Cheminement en zone de lovage',
    commentaire_arrimage_gaine: 'Commentaire',
    commentaire_cheminement_lovage: 'Commentaire',
    commentaire_detubage_fibres: 'Commentaire',
    commentaire_emplacement_geographique: 'Commentaire',
    commentaire_emplacement_lt: 'Commentaire',
    commentaire_epanouissement: 'Commentaire',
    commentaire_etiquette_baie: 'Commentaire',
    commentaire_etiquette_cable: 'Commentaire',
    commentaire_etiquette_tiroir: 'Commentaire',
    commentaire_fixation_eclateur: 'Commentaire',
    commentaire_fixation_entree: 'Commentaire',
    commentaire_fixation_tiroir: 'Commentaire',
    commentaire_longueur_gaine: 'Commentaire',
    commentaire_nombre_fibre: 'Commentaire',
    commentaire_obturation_fourreaux: 'Commentaire',
    commentaire_ouverture_tiroirs: 'Commentaire',
    commentaire_position_traverses: 'Commentaire',
    commentaire_positions_tiroirs: 'Commentaire',
    commentaire_presence_bouchons: 'Commentaire',
    commentaire_presence_gaine: 'Commentaire',
    commentaire_rayon_courbure: 'Commentaire',
    commentaire_rayon_courbure_tubes: 'Commentaire',
    commentaire_vabf_acces: 'Commentaire',
    detubage_fibres: 'Détubage des fibres et lovages des fibres',
    emplacement_geographique: 'Emplacement géographique',
    emplacement_lt: 'Emplacement dans le local technique',
    epanouissement: "Mise en uvre de l'épanouissement",
    etiquette_baie: 'Etiquette (Présente, libre et juste)',
    etiquette_cable: 'Etiquettes (Présentes, libres et justes)',
    etiquette_tiroir: 'Etiquettes (Présentes, libres et justes)',
    fixation_eclateur: "Fixation de l'éclateur (Vis et/ou écrou cage)",
    fixation_entree: 'Fixation des câbles en entrée (NRO / SRO)',
    fixation_tiroir: 'Fixation (Partie fixe + Charnière)',
    img_arrimage_gaine: 'Photos',
    img_cheminement_lovage: 'Photos',
    img_detubage_fibres: 'Photos',
    img_emplacement_geographique: 'Photos',
    img_emplacement_lt: 'Photos',
    img_epanouissement: 'Photos',
    img_etiquette_baie: 'Photos',
    img_etiquette_cable: 'Photos',
    img_etiquette_tiroir: 'Photos',
    img_fixation_eclateur: 'Photos',
    img_fixation_entree: 'Photos',
    img_fixation_tiroir: 'Photos',
    img_longueur_gaine: 'Photos',
    img_nombre_fibre: 'Photos',
    img_obturation_fourreaux: 'Photos',
    img_ouverture_tiroirs: 'Photos',
    img_position_traverses: 'Photos',
    img_positions_tiroirs: 'Photos',
    img_presence_bouchons: 'Photos',
    img_presence_gaine: 'Photos',
    img_rayon_courbure: 'Photos',
    img_rayon_courbure_tubes: 'Photos',
    img_vabf_acces: 'Photos',
    longueur_gaine: 'Longueur suffisante de la gaine annelée (Partie',
    nombre_fibre: 'Nombre de fibres de transport',
    obturation_fourreaux: 'Obturation des fourreaux du site',
    ouverture_tiroirs: 'Ouverture libre des tiroirs (Absence de frottements)',
    position_traverses: 'Positionnement des traverses (Nb U)',
    positions_tiroirs: 'Vérification de la position des tiroirs',
    presence_bouchons: 'Présence des bouchons (Connecteurs)',
    presence_gaine: 'Présence de la gaine annelée / bloolite',
    proprete: 'Propreté',
    rayon_courbure: 'Respect des rayons de courbure',
    rayon_courbure_tubes: 'Respect des rayons de courbure des tubes',
    st_abddate: "Date d'abandon de l'objet",
    st_abdsrc: "Cause de l'abandon de l'objet",
    st_ad_code: 'Identifiant unique contenu dans la table ADRESSE',
    st_avct: "Attribut synthétisant l'avancement.",
    st_code: 'Code du site',
    st_codeext: 'Code chez un tiers',
    st_comment: 'Commentaire',
    st_creadat: "Date de création de l'objet en base",
    st_dateins: "Date d'installation",
    st_datemes: 'Date de mise en service',
    st_etat: 'Etat du site.',
    st_gest: 'Identifiant du gestionnaire',
    st_majdate: "Date de la mise à jour de l'objet en base",
    st_majsrc: 'Source utilisée pour la mise à jour',
    st_nblines: 'Nombre de lignes du site.',
    st_nd_code: 'Identifiant unique contenu dans la table Noeud',
    st_nom: 'Nom du site.',
    st_prop: 'Identifiant du propriétaire',
    st_proptyp: 'Type de propriété',
    st_statut: "Phase d'avancement",
    st_typelog: 'Type logique du site',
    st_typephy: 'Type physique du site',
    st_user: 'utilisateur du site',
    statut: 'Statut audit',
    vabf_acces: "VABF du contrôle d'accès (serrure porte canon)",
};

export const options: Record<string, OptionsInterface | SelectInterface> = {
    arrimage_gaine: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    cheminement_lovage: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    detubage_fibres: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    emplacement_geographique: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    emplacement_lt: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    epanouissement: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    etiquette_baie: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    etiquette_cable: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    etiquette_tiroir: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    fixation_eclateur: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    fixation_entree: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    fixation_tiroir: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    longueur_gaine: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    nombre_fibre: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    obturation_fourreaux: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    ouverture_tiroirs: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    position_traverses: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    positions_tiroirs: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    presence_bouchons: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    presence_gaine: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    proprete: { false: 'NON', true: 'OUI' },
    rayon_courbure: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    rayon_courbure_tubes: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
    st_etat: [
        { label: 'A CHANGER', value: 'HS' },
        { label: 'MAUVAIS ETAT', value: 'ME' },
        { label: 'BON ETAT', value: 'OK' },
        { label: 'NON CONCERNE', value: 'NC' },
    ],
    st_proptyp: [
        { label: 'CONSTRUCTION', value: 'CST' },
        { label: 'RACHAT', value: 'RAC' },
        { label: 'CESSION', value: 'CES' },
        { label: 'IRU', value: 'IRU' },
        { label: 'LOCATION', value: 'LOC' },
        { label: 'OCCUPATION', value: 'OCC' },
    ],
    st_statut: [
        { label: 'ETUDE PRELIMINAIRE', value: 'PRE' },
        { label: 'ETUDE DE DIAGNOSTIC', value: 'DIA' },
        { label: 'AVANT-PROJET', value: 'AVP' },
        { label: 'PROJET', value: 'PRO' },
        { label: 'PASSATION DES MARCHES DE TRAVAUX', value: 'ACT' },
        { label: 'ETUDE D EXECUTION', value: 'EXE' },
        { label: 'TRAVAUX', value: 'TVX' },
        { label: 'RECOLEMENT', value: 'REC' },
        { label: 'MAINTIENT EN CONDITIONS OPERATIONNELLES', value: 'MCO' },
    ],
    statut: [
        { label: 'Audit à réaliser', value: 'NON EFFECTUE' },
        { label: 'Audit partiellement réalisé', value: 'PARTIEL' },
        { label: 'Audit réalisé', value: 'TERMINE' },
        { label: 'Non concerné par un audit', value: 'NON CONCERNE' },
    ],
    vabf_acces: [
        { label: 'Sans objet', value: null },
        { label: 'Conforme', value: 'Conforme' },
        { label: 'Non-conforme', value: 'Non-conforme' },
    ],
};
